// extracted by css-extract-rspack-plugin
export default {"fallback":"oYpe_Vom0IcnutHA","retry":"_BNZwg_FP0YMtQI7"};